import React from 'react';

export default function ClearedLogomark({ size = 40, className = '' }) {
  // Outer rounded square: midnight #0B1629, ~20% border radius
  // Inside: 2x2 grid of four squares
  // Top-left, top-right, bottom-left: cream #F8FAF6 outlined (stroke only)
  // Bottom-right: coral #E8877E filled
  const r = size * 0.20; // border radius (20%)
  const pad = size * 0.18; // padding from edge
  const gap = size * 0.08; // gutter between cells
  const cellSize = (size - 2 * pad - gap) / 2;
  const cellR = cellSize * 0.15; // cell border radius
  const stroke = Math.max(1.5, size * 0.05); // stroke width scales with size

  const x1 = pad;
  const x2 = pad + cellSize + gap;
  const y1 = pad;
  const y2 = pad + cellSize + gap;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {/* Outer rounded square */}
      <rect x={0} y={0} width={size} height={size} rx={r} fill="#0B1629" />

      {/* Top-left: cream outlined */}
      <rect x={x1} y={y1} width={cellSize} height={cellSize} rx={cellR}
        stroke="#F8FAF6" strokeWidth={stroke} fill="none" />

      {/* Top-right: cream outlined */}
      <rect x={x2} y={y1} width={cellSize} height={cellSize} rx={cellR}
        stroke="#F8FAF6" strokeWidth={stroke} fill="none" />

      {/* Bottom-left: cream outlined */}
      <rect x={x1} y={y2} width={cellSize} height={cellSize} rx={cellR}
        stroke="#F8FAF6" strokeWidth={stroke} fill="none" />

      {/* Bottom-right: coral filled */}
      <rect x={x2} y={y2} width={cellSize} height={cellSize} rx={cellR}
        fill="#E8877E" />
    </svg>
  );
}
